import {
  GridApi,
  IStatusPanelComp,
  IStatusPanelParams,
} from '@ag-grid-community/core'
import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'

const template = `
  <span class="hs-status-bar">
    <span class="ml-2">Success: </span> <span class="ml-1" id="call-success-value">0</span>
    <span class="ml-2">Failed: </span> <span class="ml-1" id="call-failed-value">0</span>
    <span class="ml-2">Total: </span> <span class="ml-1" id="call-total-value">0</span>
  </span>
`

export class HttpStatusStatusBar implements IStatusPanelComp {
  private api!: GridApi
  private guiElement!: HTMLElement

  /** @internal */
  readonly listener = () => this.onRowDataUpdated()

  init(params: IStatusPanelParams): void {
    this.api = params.api
    params.api.addEventListener('rowDataUpdated', this.listener)
  }

  destroy() {
    this.api.removeEventListener('rowDataUpdated', this.listener)
  }

  getGui(): HTMLElement {
    const el = loadTemplate(template)
    this.guiElement = el
    return el
  }

  /** @internal */
  onRowDataUpdated() {
    let successCount = 0
    let failedCount = 0
    let totalCount = 0

    this.api.forEachNode(node => {
      const status: number | undefined = node.data.response?.status
      if (status != null) {
        totalCount++
        if (status >= 400) failedCount++
        else successCount++
      }
    })

    const successSpan = this.guiElement.querySelector(
      '#call-success-value',
    ) as HTMLElement
    successSpan.innerText = `${successCount}`

    const failedSpan = this.guiElement.querySelector(
      '#call-failed-value',
    ) as HTMLElement
    failedSpan.innerText = `${failedCount}`

    const totalSpan = this.guiElement.querySelector(
      '#call-total-value',
    ) as HTMLElement
    totalSpan.innerText = `${totalCount}`
  }
}
